// src/components/StructuredData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const OrganizationSchema = ({ contactInfo }) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Dismhecol S.A.S",
        "alternateName": "Dismhecol",
        "url": "https://dismhecol.com",
        "logo": "https://dismhecol.com/logo192.png",
        "description": "Distribuidora de medicamentos genéricos, alto costo, éticos, comerciales, dispositivos médicos e insumos hospitalarios en Pasto, Nariño, Colombia.",
        "foundingDate": "2012-02-20",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": contactInfo?.address || "Carrera 35 A No. 20 - 99 Barrio La Rivera",
            "addressLocality": "Pasto",
            "addressRegion": "Nariño",
            "postalCode": "520001",
            "addressCountry": "CO"
        },
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": contactInfo?.tel_fijo || "+57-602-7350053",
            "contactType": "customer service",
            "areaServed": "CO",
            "availableLanguage": "Spanish"
        },
        "sameAs": [
            "https://www.facebook.com/dismhecol",
            "https://www.instagram.com/dismhecolsas/",
            "https://x.com/dismhecol"
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const LocalBusinessSchema = ({ contactInfo }) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "MedicalBusiness",
        "name": "Dismhecol S.A.S",
        "image": "https://dismhecol.com/logo192.png",
        "description": "Distribuidora de medicamentos y productos hospitalarios con más de 13 años de experiencia en Pasto, Nariño.",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": contactInfo?.address || "Carrera 35 A No. 20 - 99 Barrio La Rivera",
            "addressLocality": "Pasto",
            "addressRegion": "Nariño",
            "postalCode": "520001",
            "addressCountry": "CO"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": contactInfo?.coordinates?.lat || 1.2136,
            "longitude": contactInfo?.coordinates?.lng || -77.2811
        },
        "telephone": contactInfo?.tel_fijo || "+57-602-7350053",
        "email": contactInfo?.departments?.[0]?.email || "comercial@dismhecol.com",
        "url": "https://dismhecol.com",
        "priceRange": "$$",
        "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday"
                ],
                "opens": "08:00",
                "closes": "17:00"
            }
        ],
        "areaServed": {
            "@type": "GeoCircle",
            "geoMidpoint": {
                "@type": "GeoCoordinates",
                "latitude": 1.2136,
                "longitude": -77.2811
            },
            "geoRadius": "100000"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const WebSiteSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Dismhecol",
        "url": "https://dismhecol.com",
        "potentialAction": {
            "@type": "SearchAction",
            "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://dismhecol.com/search?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const BreadcrumbSchema = ({ items }) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": `https://dismhecol.com${item.path}`
        }))
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export default {
    OrganizationSchema,
    LocalBusinessSchema,
    WebSiteSchema,
    BreadcrumbSchema
};
